// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locked-card {
  opacity: 0.6;
  pointer-events: none;
}

.lock-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 2rem;
  animation: lockShake 1.2s infinite;
}

@keyframes lockShake {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
  75% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0);
  }
}

/* Completed Score Section */
.completed-score-section {
  margin-bottom: 12px;
}

.score-display-card {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 12px;
  border: 1px solid #bbf7d0;
}

.score-item-display,
.points-item-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.score-item-display i {
  font-size: 20px;
  color: #f59e0b;
  margin-bottom: 4px;
}

.points-item-display i {
  font-size: 20px;
  color: #eab308;
  margin-bottom: 4px;
  animation: starPulse 1.5s ease-in-out infinite;
}

@keyframes starPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.score-value-display {
  font-size: 18px;
  font-weight: 700;
  color: #166534;
}

.points-value-display {
  font-size: 18px;
  font-weight: 700;
  color: #ca8a04;
}

.score-label-display,
.points-label-display {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive adjustments */
@media (max-width: 575.98px) {
  .score-display-card {
    gap: 16px;
    padding: 10px 12px;
  }

  .score-item-display i,
  .points-item-display i {
    font-size: 18px;
  }

  .score-value-display,
  .points-value-display {
    font-size: 16px;
  }

  .score-label-display,
  .points-label-display {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/assessment.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".locked-card {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.lock-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 2rem;\n  animation: lockShake 1.2s infinite;\n}\n\n@keyframes lockShake {\n  0% {\n    transform: rotate(0);\n  }\n  25% {\n    transform: rotate(-10deg);\n  }\n  50% {\n    transform: rotate(10deg);\n  }\n  75% {\n    transform: rotate(-5deg);\n  }\n  100% {\n    transform: rotate(0);\n  }\n}\n\n/* Completed Score Section */\n.completed-score-section {\n  margin-bottom: 12px;\n}\n\n.score-display-card {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border-radius: 12px;\n  border: 1px solid #bbf7d0;\n}\n\n.score-item-display,\n.points-item-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.score-item-display i {\n  font-size: 20px;\n  color: #f59e0b;\n  margin-bottom: 4px;\n}\n\n.points-item-display i {\n  font-size: 20px;\n  color: #eab308;\n  margin-bottom: 4px;\n  animation: starPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes starPulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n}\n\n.score-value-display {\n  font-size: 18px;\n  font-weight: 700;\n  color: #166534;\n}\n\n.points-value-display {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ca8a04;\n}\n\n.score-label-display,\n.points-label-display {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 575.98px) {\n  .score-display-card {\n    gap: 16px;\n    padding: 10px 12px;\n  }\n\n  .score-item-display i,\n  .points-item-display i {\n    font-size: 18px;\n  }\n\n  .score-value-display,\n  .points-value-display {\n    font-size: 16px;\n  }\n\n  .score-label-display,\n  .points-label-display {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
